<template>
  <swiper-base ref="swiper" class="swiper-type-three" :items="items" @change="onChange">
    <template v-slot:item="{ item }">
      <slot name="item" :item="item"></slot>
    </template>

    <template v-slot:buttons>
      <u-icon-button
        v-if="hasPrevButton"
        class="swiper-type-three__button swiper-type-three__button--prev"
        icon-name="left"
        size="s"
        dark
        @click="onSwipe('end')"
      >
        prev
      </u-icon-button>
      <u-icon-button
        v-if="hasNextButton"
        class="swiper-type-three__button swiper-type-three__button--next"
        icon-name="right"
        size="s"
        dark
        @click="onSwipe('start')"
      >
        next
      </u-icon-button>
    </template>

    <template v-slot:dots>
      <swiper-pagination-dots
        class="swiper-type-three__dots"
        :total-pages="totalPages"
        :current-page-index="currentItemIndex"
        @navigate-to="navigateToPage"
      />
    </template>
  </swiper-base>
</template>

<script>
import { UIconButton } from 'universkin-shared';

import SwiperBase from '@/components/common/app-swiper/SwiperBase.vue';
import SwiperPaginationDots from '@/components/common/app-swiper/SwiperPaginationDots.vue';

export default {
  name: 'SwiperTypeThree',
  components: { SwiperBase, UIconButton, SwiperPaginationDots },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return { currentItemIndex: 0 };
  },
  computed: {
    hasPrevButton() {
      return this.currentItemIndex > 0;
    },
    hasNextButton() {
      return this.currentItemIndex < this.items.length - 1;
    },
    totalPages() {
      return this.items.length;
    }
  },
  methods: {
    onSwipe(direction) {
      this.$refs.swiper.swipeInDirection(direction);
    },
    onChange(index) {
      this.currentItemIndex = index;
      this.$emit('change', index);
    },
    navigateToPage(page) {
      this.$refs.swiper.swipeToIndex(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-type-three {
  position: relative;
  --item-width: 100%;
  --item-gap: 4px;

  &__button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &:lang(ar) {
      transform: translateY(-50%) scaleX(-1);
    }
  }

  &__button--prev:not(:lang(ar)),
  &__button--next:lang(ar) {
    left: 16px;
  }

  &__button--next:not(:lang(ar)),
  &__button--prev:lang(ar) {
    right: 16px;
  }

  &__dots {
    position: relative;
    margin-top: 16px;
  }
}

@media (min-width: 960px) {
  .swiper-type-three {
    &__dots {
      margin-top: 24px;
    }
  }
}
</style>
